import type { AppContext } from 'types/common'

import PartSearch from './PartSearch.svelte'
import { graphql } from '$houdini'
import { getSession } from 'stores/session'
import { type ParsedStateParameters, jsonParseParameters } from 'utility/search-fields'

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'app.part-search',
		route: 'part-search',
		template: {
			svelte: true,
			component: PartSearch,
		},
		async resolve(_stateRouterData, parameters) {
			const { id: userAccountId, currentStore } = getSession()

			const parsedParameters: ParsedStateParameters = {}
			for (const key in parameters) {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
				parsedParameters[key] = jsonParseParameters.has(key) ? JSON.parse(parameters[key]) : parameters[key]
			}

			const { data } = await dataQuery.fetch({ variables: { userAccountId, filter: { searchable: true } } })

			return {
				parsedParameters,
				searchModules: data?.session?.userAccount?.searchModules ?? [],
				authorizedStores: data?.userAccount?.authorizedStores ?? [],
				searchableInventoryFields: data?.inventoryFields ?? [],
				stores: currentStore ? [currentStore] : [], //This is the list of selected stores, so by default it will be their currently logged in store
				userPinnedSearchFields: data?.session?.userAccount?.settings?.searchParts?.pinnedSearchFields ?? [],
			}
		},
	})
}

const dataQuery = graphql(`
	query PartSearchData($userAccountId: Int!, $filter: InventoryFieldsFilter!) {
		userAccount(id: $userAccountId) {
			authorizedStores {
				id
				name
				code
			}
		}
		session {
			userAccount {
				searchModules {
					default
					module {
						id
						name
					}
				}
				settings {
					searchParts {
						pinnedSearchFields
					}
				}
			}
		}
		inventoryFields(filter: $filter) {
			id
			displayName
			fieldType
			fieldOptions
			searchByRange
			searchMode
			fieldName
		}
	}
`)
